import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import SurveyFormsAPI from '../../api/surveyForms';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getSurveyForms(_state) {
    return _state.records;
  },
  getSurveyForm: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit(types.SET_SURVEY_FORMS_UI_FLAG, { isFetching: true });
    try {
      const response = await SurveyFormsAPI.get();
      commit(types.SET_SURVEY_FORMS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SURVEY_FORMS_UI_FLAG, { isFetching: false });
    }
  },

  show: async function show({ commit }, id) {
    commit(types.SET_SURVEY_FORMS_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await SurveyFormsAPI.show(id);
      commit(types.ADD_SURVEY_FORM, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SURVEY_FORMS_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async function create({ commit }, surveyFormObj) {
    commit(types.SET_SURVEY_FORMS_UI_FLAG, { isCreating: true });
    try {
      const response = await SurveyFormsAPI.create(surveyFormObj);
      commit(types.ADD_SURVEY_FORM, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_SURVEY_FORMS_UI_FLAG, { isCreating: false });
    }
  },

  update: async function update({ commit }, { id, ...updateObj }) {
    commit(types.SET_SURVEY_FORMS_UI_FLAG, { isUpdating: true });
    try {
      const response = await SurveyFormsAPI.update(id, updateObj);
      commit(types.EDIT_SURVEY_FORM, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_SURVEY_FORMS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteSurveyForm({ commit }, id) {
    commit(types.SET_SURVEY_FORMS_UI_FLAG, { isDeleting: true });
    try {
      await SurveyFormsAPI.delete(id);
      commit(types.DELETE_SURVEY_FORM, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_SURVEY_FORMS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_SURVEY_FORMS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_SURVEY_FORMS]: MutationHelpers.set,
  [types.ADD_SURVEY_FORM]: MutationHelpers.setSingleRecord,
  [types.EDIT_SURVEY_FORM]: MutationHelpers.update,
  [types.DELETE_SURVEY_FORM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
